<form [formGroup]="newUserForm" class="grid" autocomplete="off">
    
    <!-- FirstName -->

    <div class="form-group col-6">
        <input class="w-full" [placeholder]="'USER.FIRST_NAME' | translate" pInputText formControlName="FirstName" name="FirstName" id="FirstName"/>
    </div>

    <!-- LastName -->
    
    <div class="form-group col-6">
        <input class="w-full" [placeholder]="'USER.LAST_NAME' | translate" pInputText formControlName="LastName" name="LastName" id="LastName"/>
    </div>

    <!-- Phone -->

    <div class="form-group col-6">
        <input class="w-full" [placeholder]="'USER.PHONE' | translate" pInputText formControlName="Phone" name="Phone" id="Phone"/>
    </div>

    <!-- Email -->
    
    <div class="form-group col-6">
        <input class="w-full" [placeholder]="'USER.MAIL' | translate" pInputText autocomplete="off" formControlName="Mail" name="NewMail" id="NewMail"/>
    </div>

    <!-- Password -->

    <password controlName="Password" class="col-12" placeholder="LOGIN.ENTER_PASSWORD" (passwordChanged)="onPasswordChanged()"></password>

    <!-- Confirm Password -->

    <password controlName="PasswordConfirm" class="col-12" placeholder="LOGIN.CONFIRM_PASSWORD" [action]="startRegistration.bind(this)"></password>

</form>
